import { forwardRef } from 'react';

import './textarea.scss';

export const Textarea = forwardRef(
  (
    {
      label,
      name,
      value,
      placeholder,
      onChange,
      onFocus,
      required,
      filled,
      bordered,
      style,
      rows = 4,
      error,
      display = false
    },
    ref
  ) => {
    const handleOnChange = (event) => {
      const { name, value } = event.target;
      onChange({ name, value });
    };

    return (
      <div
        className={`form-textarea ${filled ? 'form-textarea--filled' : ''} ${bordered ? 'form-textarea--bordered' : ''} 
      ${!!error ? 'form-textarea--error' : ''}`}
        style={style}
      >
        {label && (
          <label htmlFor={name}>
            {label}
            {required && !display && <span> *</span>}
          </label>
        )}
        <textarea
          ref={ref}
          id={name}
          name={name}
          rows={rows}
          value={value}
          placeholder={placeholder}
          onChange={handleOnChange}
          onFocus={onFocus}
          readOnly={display}
        />
      </div>
    );
  }
);
